import { useTranslation } from "react-i18next";
import { useSiteInfo } from "../components/StoreInfoCard";
import { useStoreHours, formatStoreHours } from "../lib/hours";
import "./legal.css";

export function Contact() {
  const { t } = useTranslation();
  const { data: info } = useSiteInfo();
  const { data: hours } = useStoreHours();

  return (
    <article className="container legal contact">
      <h1>{t("contact.title")}</h1>
      <p>{t("contact.intro")}</p>

      <dl className="contact__list">
        <dt>{t("contact.address")}</dt>
        <dd>
          {info?.address ?? "—"}
          {info?.mapsUrl && (
            <>
              {" · "}
              <a href={info.mapsUrl} target="_blank" rel="noopener noreferrer">
                {t("contact.viewMap")}
              </a>
            </>
          )}
        </dd>

        {hours && (
          <>
            <dt>{t("contact.hours")}</dt>
            <dd>{formatStoreHours(hours.days, t)}</dd>
          </>
        )}

        {info?.phone && (
          <>
            <dt>{t("contact.phone")}</dt>
            <dd>
              <a href={`tel:${info.phone.replace(/\s/g, "")}`}>{info.phone}</a>
            </dd>
          </>
        )}

        {info?.email && (
          <>
            <dt>{t("contact.email")}</dt>
            <dd>
              <a href={`mailto:${info.email}`}>{info.email}</a>
            </dd>
          </>
        )}

        {(info?.facebook || info?.instagram) && (
          <>
            <dt>{t("contact.social")}</dt>
            <dd className="contact__social">
              {info?.facebook && (
                <a href={info.facebook} target="_blank" rel="noopener noreferrer">
                  Facebook
                </a>
              )}
              {info?.instagram && (
                <a href={info.instagram} target="_blank" rel="noopener noreferrer">
                  Instagram
                </a>
              )}
            </dd>
          </>
        )}
      </dl>
    </article>
  );
}
